import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'DatePicker';

class DatePicker extends BaseComponent {
	format = "YYYY-MM-DD";
	constructor(element) {
		super(element);
		this._changeCallbacks = [];
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	set dataValue(value) {
		this._dataValue = value;
		this.datePicker.value = this._dataValue;
		if (value === '') {
			this.clearDateData();
		} else {
			this.setDate();
		}
	}

	get dataValue() {
		return this._dataValue;
	}

	init() {
		this.datePicker = this._element.querySelector("duet-date-picker");
		this.toggleButton = this.datePicker.querySelector('.duet-date__toggle');
		this.clearButton = this._element.querySelector('.lta-datepicker__clear-icon');
		this.calendarButton = this._element.querySelector('.lta-datepicker__calendar-icon');

		window.customElements.whenDefined("duet-date-picker")
			.then(() => {
				const interval = setInterval(() => {
					this.input = this.datePicker.querySelector('.duet-date__input');
					if (this.input) {
						clearInterval(interval);
						this.initDatepicker();
					}
				}, 500);
				return true;
			}).catch((error) => console.error(error));
	}

	initDatepicker() {
		this.toggleButton = this.datePicker.querySelector('.duet-date__toggle');
		this.clearButton = this._element.querySelector('.lta-datepicker__clear-icon');
		this.calendarButton = this._element.querySelector('.lta-datepicker__calendar-icon');

		// Making datepicker input component readonly.
		this.input.setAttribute('readonly', true);

		// Disabling tab stop on hidden togglebutton.
		this.toggleButton.setAttribute('tabindex', '-1');

		const placeholder = this.datePicker.getAttribute('placeholder');

		if (placeholder) {
			this.input.setAttribute('placeholder', placeholder);
		}

		// eslint-disable-next-line promise/always-return
		if (this.datePicker) {
			// Open Datepicker when click / keyboard keypress event on input occurs.
			EventHandler.on(this.input, 'click', this.openDatePicker.bind(this));
			EventHandler.on(this.input, 'keypress', this.openDatePicker.bind(this));
			EventHandler.on(this.datePicker, 'duetChange', this.dateChangeHandler.bind(this));
			EventHandler.on(this.clearButton, 'click', this.clearDate.bind(this));
			EventHandler.on(this.clearButton, 'keypress', this.clearDate.bind(this));
			EventHandler.on(this.calendarButton, 'click', this.openDatePicker.bind(this));
			EventHandler.on(this.calendarButton, 'keypress', this.openDatePicker.bind(this));
		}

		this.dateParser();
	}

	async dateParser() {
		const dayjs = await import('dayjs');
		const DATE_FORMAT = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
		const _this = this;

		this.datePicker.dateAdapter = {
			parse(value = '', createDate) {
				const matches = value.match(DATE_FORMAT);
				return matches ? createDate(matches[3], matches[2], matches[1]) : '';
			},
			format(date) {
				return dayjs.default(date).format(_this.format || 'YYYY-MM-DD');
			}
		};
	}

	onChange(callback) {
		this._changeCallbacks.push(callback);
	}

	dateChangeHandler(event) {
		const { detail: { value } } = event;
		if (value) {
			this.setDate(value);
			for (const callback of this._changeCallbacks) {
				callback(value);
			}
		}
	}

	setDate() {
		this.clearButton?.classList.remove('u-hidden');
		this.calendarButton?.classList.add('u-hidden');
	}

	clearDate() {
		this.dataValue = '';
		for (const callback of this._changeCallbacks) {
			callback();
		}
	}

	clearDateData() {
		this.clearButton.classList.add('u-hidden');
		this.calendarButton.classList.remove('u-hidden');
	}

	openDatePicker() {
		this.datePicker.show();
	}
}

export default DatePicker;
